import React from 'react';

var componentName = '[@vp/om-currency]';
var fallbackString = '...'; // TODO: do we want to make fallback string configurable?
var validateFractionDigits = function (currency, fracionDigits) {
    if (!currency) {
        var errMsg = "".concat(componentName, " Currency is required but got ").concat(currency);
        throw errMsg;
    }
    if (typeof fracionDigits === 'number' && fracionDigits >= 0) {
        return fracionDigits;
    }
    // Fraction digits is either NaN, or negative number...
    // no bueno, but we can find a fallback since currency is not falsy here
    return currency.toUpperCase() === 'JPY' ? 0 : 2;
};
var isCentInvalid = function (cents) {
    if (typeof cents !== 'number') {
        console.error("".concat(componentName, ": Prop 'cents' should be a number, but got ").concat(cents, "."));
        return true;
    }
    return false;
};
/**
 * Formatter for currency
 * @param locale OM-supported locale, e.g. 'en-IE'
 * @param currency OM-supported currency, e.g. 'EUR'
 * @param cents amount in minor unit
 * @param fractionDigits fraction digit of the currency
 */
var currencyFormatter = function (locale, currency, cents, fractionDigits) {
    if (isCentInvalid(cents)) {
        return fallbackString;
    }
    try {
        var validatedFractionDigits = validateFractionDigits(currency, fractionDigits);
        return Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
        }).format(cents / Math.pow(10, validatedFractionDigits));
    }
    catch (error) {
        console.error(componentName, error);
        return fallbackString;
    }
};
/**
 * Wrapper for currencyFormatter
 * @param props takes locale, currency, cents and fractionDigits for currencyFormatter
 */
var Currency = function (_a) {
    var cents = _a.cents, currency = _a.currency, locale = _a.locale, fractionDigits = _a.fractionDigits;
    return React.createElement("span", null, currencyFormatter(locale, currency, cents, fractionDigits));
};

export { Currency, currencyFormatter };
//# sourceMappingURL=index.esm.js.map
